/**
 * Show or hide fields, change field values, or send specific notifications all based upon user input.
 */

var ConditionalFields = function () {};

ConditionalFields.prototype = {
    /**
     * Conditionally change visibility of a field upon selecting option (on dropdown) or checking radio/checkbox buttons.
     *
     * @param {Object} selector     jQuery selector - The clicked/selected element
     * @param {Object} target       jQuery selector - The target element (will be displayed or hidden)
     * @param {string} value        Value to compare
     * @param {string} operator     Comparison operator (for e.g. '==' or '!=')
     */
    onChange: function(selector, target, value, operator) {
        var $this = this;

        // Checkbox or radio button
        if (selector.attr('type') !== "undefined" && (selector.attr('type') === 'checkbox' || selector.attr('type') === 'radio')) {
            selector.change(function () {
                if (jQuery(this).is(":checked")) {
                    if (target.parent().parent().hasClass("row")) {
                        target.parent().removeClass('hidden');
                    } else {
                        target.parent().parent().removeClass('hidden');
                    }
                } else {    
                    if (target.parent().parent().hasClass("row")) {
                        target.parent().addClass('hidden');
                    } else {
                        target.parent().parent().addClass('hidden');
                    }
                }
            });
        }
        // Dropdown
        else {  
            selector.change(function () {
                // Check if the selection'is contains a number => means that it comes from a infinite field
                if (/\d/.test(jQuery(this).attr("id"))) {
                    // The target is the field in the same div as the selector (not the other similar fields)
                    target = jQuery(this).parents('tbody').find(target);
                } 

                if ($this.inputCompare(jQuery(this).val(), value, operator)) {            
                    if (target.parent().parent().hasClass("row")) {
                        target.parent().removeClass('hidden');
                    } else {
                        target.parent().parent().removeClass('hidden');
                    }         
                } else {
                    if (target.parent().parent().hasClass("row")) {
                        target.parent().addClass('hidden');
                    } else {
                        target.parent().parent().addClass('hidden');
                    }
                }
            });

            // On page load, hide or display the target
            if ($this.inputCompare(selector.val(), value, operator)) {
                
                if (target.parent().parent().hasClass("row")) {
                    target.parent().removeClass('hidden');
                } else {
                    target.parent().parent().removeClass('hidden');
                }
                
            } else {
                
                if (target.parent().parent().hasClass("row")) {
                    target.parent().addClass('hidden');
                } else {
                    target.parent().parent().addClass('hidden');
                }
            }
        }
    },

    inputCompare: function(a, b, operator) {
        var result = false;

        if (a == '' || b == '') { // For empty value on page load (e.g. '-- Selectionner --')
            return result;
        }

        switch (operator) {
            case '>':   result = a > b; break;
            case '<':   result = a < b; break;
            case '>=':  result = a >= b; break;
            case '<=':  result = a <= b; break;
            case '==':  result = a == b; break;
            case '!=':  result = a != b; break;
            case '===': result = a === b; break;
            case '!==': result = a !== b; break;
        }

        return result;
    },
};

module.exports = new ConditionalFields();
